module.exports = __webpack_public_path__ + "img/未开始.6137117e.png";